// Só os bancos com código — é o que os fluxos de conta/ativo precisam, porque
// lá o código é o identificador que o usuário reconhece e que casa com o
// extrato da corretora.
const lista = (state) => {
  return state.lista.data.filter((item) => {
    return (item.codigo || item.codigo_corretora) > 0
  })
}

// TODOS os bancos, inclusive os sem código.
//
// O filtro de `lista` esconde cadastros reais: das quatro linhas que casam
// "BTG" em `app_banco`, três não têm código (`BTG PACTUAL CM LTDA.` 285,
// `BTG PACTUAL CTVM S.A.` 286, `BTG Pactual Bank US` 446). Onde a escolha é
// por `id_banco` — e não pelo código —, esconder essas linhas impediria
// vincular a corretora certa.
//
// Getter próprio, e não uma flag em `lista`: os 3 consumidores atuais dependem
// do filtro, e mudá-lo alcançaria telas que este trabalho não toca.
const listaCompleta = (state) => state.lista.data

const listaLoading = (state) => {
  return state.lista.loading
}

export { lista, listaCompleta, listaLoading }
